@if (readonly) {
  <span class="dxc-rating__stars" role="img" [attr.aria-label]="summary">
    @for (n of stars; track n) {
      <span class="dxc-rating__star" aria-hidden="true">
        <span class="dxc-rating__mark">
          <dxc-icon name="estrella"></dxc-icon>
          @if (fill(n) > 0) {
            <span class="dxc-rating__fill" [style.width.%]="fill(n)"><dxc-icon name="estrella"></dxc-icon></span>
          }
        </span>
      </span>
    }
  </span>
} @else {
  <span class="dxc-rating__stars" role="radiogroup" [attr.aria-label]="ariaLabel || 'Calificación'"
    (mouseleave)="preview = null">
    @for (n of stars; track n) {
      <button type="button" role="radio" class="dxc-rating__star"
        [attr.aria-checked]="rounded === n" [attr.aria-label]="n + ' de ' + max"
        [tabindex]="tabStop === n ? 0 : -1" [disabled]="disabled"
        (mouseenter)="preview = n" (click)="select(n)" (keydown)="onKeydown($event)" (blur)="touch()">
        <span class="dxc-rating__mark">
          <dxc-icon name="estrella"></dxc-icon>
          @if (fill(n) > 0) {
            <span class="dxc-rating__fill" [style.width.%]="fill(n)"><dxc-icon name="estrella"></dxc-icon></span>
          }
        </span>
      </button>
    }
  </span>
}

@if (showValue && value > 0) {
  <span class="dxc-num dxc-rating__value">{{ valueText }}</span>
}
@if (count !== undefined && count !== null) {
  <span class="dxc-rating__count">({{ count }})</span>
}
